import React, { FC, ReactNode } from 'react';
import {
  Box,
  HStack,
  Tooltip,
  Text,
  Flex,
  ChakraProps,
  PlacementWithLogical
} from '@chakra-ui/react';
import { Icon, IconName } from '@app/components/Icon';

interface Props extends ChakraProps {
  variant:
    | 'new'
    | 'verified'
    | 'boost'
    | 'points'
    | 'event'
    | 'active_pool'
    | 'nitro_pool';
  icon?: IconName;
  iconComponent?: ReactNode;
  label?: ReactNode;
  tooltip: ReactNode | string | string[];
  tooltipPlacement?: PlacementWithLogical;
}

export const Badge: FC<Props> = ({
  variant,
  icon,
  label,
  tooltip,
  tooltipPlacement,
  iconComponent,
  ...rest
}) => {
  let color;

  switch (variant) {
    case 'new': {
      color = 'purple.1';
      break;
    }
    case 'verified': {
      color = 'green.1';
      break;
    }
    case 'boost': {
      color = 'white';
      break;
    }
    case 'event': {
      color = 'green.2';
      break;
    }
    case 'nitro_pool': {
      color = 'nitro';
      break;
    }
    case 'points':
    default: {
      color = 'orange';
    }
  }

  return (
    <Tooltip
      label={
        <Box
          sx={{
            padding: '8px 14px',
            backgroundColor: 'gray.2',
            borderRadius: '10px',
            color,
            fontSize: 14
          }}
        >
          {Array.isArray(tooltip)
            ? tooltip.map(row => <div key={row}>&bull;{row}</div>)
            : tooltip}
        </Box>
      }
      portalProps={{ appendToParentPortal: true }}
      placement={tooltipPlacement ?? 'top'}
      zIndex={1000000}
    >
      <HStack gap="4px" alignItems="center" {...rest}>
        {icon && (
          <Icon
            name={icon}
            style={{
              color: `var(--chakra-colors-${color.replace('.', '-')})`,
              width: '20px',
              height: '20px'
            }}
          />
        )}
        {iconComponent}

        {label &&
          (typeof label === 'string' ? (
            <Flex
              sx={{
                border: '1px solid',
                borderColor: color,
                borderRadius: '3px',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2px 6px'
              }}
            >
              <Text
                fontSize="14px"
                fontWeight={500}
                color={color}
                textTransform="capitalize"
              >
                {label}
              </Text>
            </Flex>
          ) : (
            label
          ))}
      </HStack>
    </Tooltip>
  );
};
